import { render, staticRenderFns } from "./SeminarEntryMessageHistoryFromApplicant.vue?vue&type=template&id=4e86c846"
import script from "./SeminarEntryMessageHistoryFromApplicant.vue?vue&type=script&lang=js"
export * from "./SeminarEntryMessageHistoryFromApplicant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports